import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const hokatsuItsukara: BlogMetaData = {
  title: '保活はいつから始める？後悔しないスケジュールと自治体確認のポイント',
  description:
    '保活はいつから始めるのが正解？妊娠中〜育休中の早期層向けに、全国でほぼ共通する保活の流れ、自治体ごとに違うポイント、情報収集から見学予約までの進め方を解説します。',
  thumbnailUrl: '/img/blog-hokatsu-itsukara.webp',
  filePath: buildBlogFilePath('hokatsu-itsukara'),
  category: BLOG_CATEGORY.NURSERY,
};
